<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域：适配消毒柜字段 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="消毒柜编号">
                        <el-input v-model="searchForm.deviceID" placeholder="请输入消毒柜编号"></el-input>
                    </el-form-item>
                    <el-form-item label="消毒目标">
                        <el-input v-model="searchForm.target" placeholder="如：左柜/右柜/单柜"></el-input>
                    </el-form-item>
                    <el-form-item label="消毒状态">
                        <el-select v-model="searchForm.status" placeholder="选择消毒状态" clearable>
                            <el-option label="已完成" value="1"></el-option>
                            <el-option label="未完成" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="消毒日期">
                        <el-date-picker v-model="searchForm.date" type="date" placeholder="选择消毒日期"
                            value-format="YYYY-MM-DD" clearable></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch()" icon="el-icon-search">查询</el-button>
                        <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域：替换为消毒柜实体字段 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="displayRecordList" height="61vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceID" label="消毒柜编号" align="center" />
                    <el-table-column prop="startName" label="开始消毒操作人" align="center" />
                    <el-table-column prop="endName" label="结束消毒操作人" align="center" />
                    <el-table-column prop="currentTemp" label="消毒温度上限(℃)" align="center" />
                    <el-table-column prop="target" label="消毒目标" align="center" />
                    <el-table-column prop="date" label="消毒日期" align="center" />
                    <el-table-column prop="startTime" label="开始时间" align="center" />
                    <el-table-column prop="endTime" label="结束时间" align="center" />
                    <el-table-column label="消毒总时长(分钟)" align="center">
                        <template #default="scope">
                            {{ calculateTotalTime(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="estimatedTime" label="预计消毒时长(分钟)" align="center" />
                    <el-table-column prop="status" label="消毒状态" align="center">
                        <template #default="scope">
                            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'">
                                {{ scope.row.status === 1 ? '已完成' : '未完成' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="notes" label="消毒备注" align="center" show-overflow-tooltip />
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount" :disabled="loading">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getRecord } from "@/api/cabinet";
export default {
    data() {
        return {
            // 搜索表单：对齐后端实体字段
            searchForm: {
                deviceID: '',       // 消毒柜编号
                target: '',          // 消毒目标
                status: '',          // 消毒状态
                date: ''             // 消毒日期
            },
            // 原始全量数据（从接口加载）
            allRecordList: [],
            // 筛选后的全量数据
            filteredRecordList: [],
            // 当前页展示的数据
            displayRecordList: [],
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            // 加载状态
            loading: false
        };
    },
    mounted() {
        // 初始化：加载全部数据
        this.getList();
    },
    methods: {
        // 从接口加载数据
        async getList() {
            this.loading = true;
            try {
                const response = await getRecord({ userId: localStorage.getItem('userId') });
                console.log('接口返回数据:', response);

                // 存储原始数据
                this.allRecordList = response.data || [];

                // 初始化筛选（显示全部数据）
                this.filteredRecordList = [...this.allRecordList];

                // 更新总数并分页
                this.totalCount = this.filteredRecordList.length;
                this.paginateData();

                // 无数据提示
                if (this.totalCount === 0) {
                    this.$message.info('暂无消毒记录数据');
                }
            } catch (error) {
                console.error('加载消毒记录失败:', error);
                this.$message.error('加载消毒记录失败，请重试');
                this.allRecordList = [];
                this.filteredRecordList = [];
                this.displayRecordList = [];
                this.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },

        // 处理查询（前端筛选核心逻辑）
        handleSearch() {
            this.loading = true;

            try {
                // 重置页码到第一页
                this.currentPage = 1;

                // 前端筛选逻辑：逐条件过滤全量数据
                this.filteredRecordList = this.allRecordList.filter(item => {
                    // 1. 消毒柜编号筛选（模糊匹配，忽略大小写）
                    if (this.searchForm.deviceID) {
                        const deviceID = (item.deviceID || '').toLowerCase();
                        const searchVal = this.searchForm.deviceID.toLowerCase();
                        if (!deviceID.includes(searchVal)) return false;
                    }

                    // 2. 消毒目标筛选（模糊匹配）
                    if (this.searchForm.target) {
                        const target = (item.target || '').toLowerCase();
                        const searchVal = this.searchForm.target.toLowerCase();
                        if (!target.includes(searchVal)) return false;
                    }

                    // 3. 消毒状态筛选（精确匹配）
                    if (this.searchForm.status !== '') {
                        if (item.status !== Number(this.searchForm.status)) return false;
                    }

                    // 4. 消毒日期筛选（精确匹配）
                    if (this.searchForm.date) {
                        if (item.date !== this.searchForm.date) return false;
                    }

                    // 所有条件都满足
                    return true;
                });

                // 更新总数并分页
                this.totalCount = this.filteredRecordList.length;
                this.paginateData();

                // 无数据提示
                if (this.totalCount === 0) {
                    this.$message.info('未查询到符合条件的消毒记录');
                }
            } catch (error) {
                console.error('筛选数据失败:', error);
                this.$message.error('查询失败，请重试');
            } finally {
                this.loading = false;
            }
        },

        // 分页处理：根据当前页和页大小切割数据
        paginateData() {
            if (this.filteredRecordList.length === 0) {
                this.displayRecordList = [];
                return;
            }

            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.displayRecordList = this.filteredRecordList.slice(startIndex, endIndex);
        },

        // 重置搜索条件
        resetSearch() {
            // 清空搜索表单
            this.searchForm = {
                deviceID: '',
                target: '',
                status: '',
                date: ''
            };

            // 重置筛选数据为全部数据
            this.filteredRecordList = [...this.allRecordList];
            this.currentPage = 1;
            this.totalCount = this.filteredRecordList.length;
            this.paginateData();

            this.$message.info('搜索条件已重置');
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 重置到第一页
            this.paginateData();
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateData();
        },

        // 计算消毒总时长（分钟）：结束时间 - 开始时间
        calculateTotalTime(row) {
            if (!row.startTime || !row.endTime || !row.date) return '——';

            try {
                // 拼接日期+时间，计算时间差
                const start = new Date(`${row.date} ${row.startTime}`);
                const end = new Date(`${row.date} ${row.endTime}`);

                // 检查日期是否有效
                if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                    return '——';
                }

                const diffMinutes = Math.floor((end - start) / 60000);
                return diffMinutes > 0 ? diffMinutes : '——';
            } catch (error) {
                console.error('计算时长失败:', error);
                return '——';
            }
        },

        // 表格行点击事件（选中/取消选中行）
        handleRowClick(row) {
            this.$refs.tableRef?.toggleRowSelection(row);
        }
    }
};
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 10px;
}

// 优化标签样式
:deep(.el-tag) {
    font-size: 12px;
    padding: 2px 8px;
}

// 表格溢出提示优化
:deep(.el-table .cell) {
    white-space: nowrap;
}

// 分页样式优化
:deep(.el-pagination) {
    margin-top: 15px;
}
</style>